<template>
  <div class="modal__wrap--bg cmp-modal" :class="{'is-active' : companyAppViewModal}" id="company-app-view-template">
    <div class="modal-wrap-container modal-wd1020">
      <div class="modal-header">
        <h2 class="title">기업 신청 정보 조회</h2>
      </div>
      <div class="modal-body-container ht-full" ref="modalBody">
        <div class="tab-wid-full tab-container-full">
          <div class="tab-head">
            <div class="tab-menu-wrap" role="tablist">
              <button type="button" class="tab-menu" role="tab" :aria-selected="showTab === 'basicInfo'" :class="{ 'is-active' : showTab === 'basicInfo' }"
                      data-tab="basicInfo" @click="changeTab('basicInfo')">
                기본정보
                <span class="sr-only" v-if="showTab === 'basicInfo'">선택됨</span>
              </button>
              <button type="button" class="tab-menu" role="tab" :aria-selected="showTab === 'additionalInfo'" :class="{ 'is-active' : showTab === 'additionalInfo' }"
                      data-tab="additionalInfo" @click="changeTab('additionalInfo')">
                추가 입력 사항
                <span class="sr-only" v-if="showTab === 'additionalInfo'">선택됨</span>
              </button>
            </div>
          </div>
          <div class="tab-content__wrap">
            <!-- 기본정보 탭 -->
            <div class="tab-content" :class="{ 'is-active' : showTab === 'basicInfo' }" id="basicInfo">
              <div class="form-section">
                <h3 class="section-title mt-40">기본정보</h3>
                <div class="mo-type">
                  <div class="table-wrap no-line-mg">
                    <table class="table-body-only">
                      <caption>기업 정보 테이블</caption>
                      <colgroup class="pc-cell">
                        <col style="width: 160px">
                        <col>
                      </colgroup>
                      <colgroup class="mo-cell">
                        <col style="width: 88px">
                        <col>
                      </colgroup>
                      <tbody>
                      <tr>
                        <th scope="row">기업명<span class="must">*</span></th>
                        <td>
                          <div class="flex align-items-center height-100p">
                            {{ editableData.COMPNM || '-' }}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">대표자명<span class="must">*</span></th>
                        <td>
                          <div class="flex align-items-center height-100p">
                            {{ editableData.RPSTR_NM || '-' }}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">사업자등록번호<span class="must">*</span></th>
                        <td>
                          <div class="flex align-items-center height-100p">
                            {{ editableData.COM_NO || '-' }}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">소재지<span class="must">*</span></th>
                        <td>
                          <span>{{ editableData.ZIPCODE || '' }}</span><br>
                          <span>{{ editableData.ADDR || '' }}</span><br>
                          <span>{{ editableData.ADDR_DTL || '' }}</span>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">주요사업<span class="must">*</span></th>
                        <td>
                          <div class="input-area input-size-md">
                            <input type="text" v-model="editableData.MAIN_BSNS_DESC" :disabled="!isEditMode" title="주요사업" ref="firstInput">
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">상시근로자수<span class="must">*</span></th>
                        <td>
                          <div class="flex align-items-center">
                            <div class="input-area">
                              <input type="text" v-model="editableData.FLTM_WRKR_CNT" :disabled="!isEditMode" title="상시근로자수">
                            </div>
                            <span class="font-body-style4" style="margin-left: 8px">명</span>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">매출액<span class="must">*</span></th>
                        <td>
                          <div class="flex align-items-center flex-wrap-wrap gap8">
                            <span class="font-body-style4">전년도 기준</span>
                            <div class="input-area">
                              <input type="text" v-model="editableData.SALAMT" :disabled="!isEditMode" title="매출액 (전년도 기준)">
                            </div>
                            <span class="font-body-style4" style="margin-left: 8px">천원</span>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">전화번호<span class="must">*</span></th>
                        <td>
                          <div class="flex align-items-center flex-wrap-wrap gap8">
                            <div class="input-area">
                              <input type="text" v-model="editableData.TEL_1" :disabled="!isEditMode" maxlength="3" placeholder="02" title="전화번호 앞자리">
                            </div>
                            <span class="font-body-style4">-</span>
                            <div class="input-area">
                              <input type="text" v-model="editableData.TEL_2" :disabled="!isEditMode" maxlength="4" placeholder="1234" title="전화번호 중간자리">
                            </div>
                            <span class="font-body-style4">-</span>
                            <div class="input-area">
                              <input type="text" v-model="editableData.TEL_3" :disabled="!isEditMode" maxlength="4" placeholder="5678" title="전화번호 뒷자리">
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">휴대폰<span class="must">*</span></th>
                        <td>
                          <div class="flex align-items-center flex-wrap-wrap gap8">
                            <div class="input-area">
                              <input type="text" v-model="editableData.HP_1" :disabled="!isEditMode" title="휴대폰 앞자리">
                            </div>
                            <span class="font-body-style4">-</span>
                            <div class="input-area">
                              <input type="text" v-model="editableData.HP_2" :disabled="!isEditMode" title="휴대폰 중간자리">
                            </div>
                            <span class="font-body-style4">-</span>
                            <div class="input-area">
                              <input type="text" v-model="editableData.HP_3" :disabled="!isEditMode" title="휴대폰 뒷자리">
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">팩스번호</th>
                        <td>
                          <div class="flex align-items-center flex-wrap-wrap gap8">
                            <div class="input-area">
                              <input type="text" v-model="editableData.FAX_1" :disabled="!isEditMode" title="팩스번호 앞자리">
                            </div>
                            <span class="font-body-style4">-</span>
                            <div class="input-area">
                              <input type="text" v-model="editableData.FAX_2" :disabled="!isEditMode" title="팩스번호 중간자리">
                            </div>
                            <span class="font-body-style4">-</span>
                            <div class="input-area">
                              <input type="text" v-model="editableData.FAX_3" :disabled="!isEditMode" title="팩스번호 뒷자리">
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">담당자명<span class="must">*</span></th>
                        <td>
                          <div class="input-area input-size-md">
                            <input type="text" v-model="editableData.CHARGR_NM" :disabled="!isEditMode" title="담당자명">
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">이메일<span class="must">*</span></th>
                        <td>
                          <div class="input-group email-group">
                            <div class="items1">
                              <div class="input-area wid200">
                                <input type="text" v-model="emailLocal" :disabled="!isEditMode" placeholder="1234" title="이메일 계정">
                              </div>
                              <div class="dash">@</div>
                            </div>
                            <div class="items2">
                              <div class="input-area wid200">
                                <select v-model="emailDomain" :disabled="!isEditMode" @change="onEmailDomainChange" title="이메일 도메인 선택">
                                  <option value="">이메일 도메인 선택</option>
                                  <option value="naver.com">naver.com</option>
                                  <option value="hanmail.net">hanmail.net</option>
                                  <option value="daum.net">daum.net</option>
                                  <option value="gmail.com">gmail.com</option>
                                  <option value="google.com">google.com</option>
                                  <option value="nate.com">nate.com</option>
                                  <option value="yahoo.com">yahoo.com</option>
                                  <option value="paran.com">paran.com</option>
                                  <option value="korea.com">korea.com</option>
                                  <option value="freechal.com">freechal.com</option>
                                  <option value="etc">직접입력</option>
                                </select>
                              </div>
                              <div class="input-area wid200" v-show="emailDomain === 'etc'">
                                <input type="text" v-model="emailDirectDomain" :disabled="!isEditMode" placeholder="email.com" title="이메일 도메인 (직접입력)">
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">홈페이지</th>
                        <td>
                          <div class="input-area input-size-md">
                            <input type="text" v-model="editableData.HOMEPG" :disabled="!isEditMode" title="홈페이지">
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <!-- 추가 입력사항 탭 -->
            <div class="tab-content" :class="{ 'is-active' : showTab === 'additionalInfo' }" id="additionalInfo">

              <!-- 신청사항 섹션 -->
              <div class="form-section">
                <h3 class="section-title mt-40">신청사항</h3>
                <div class="mo-type">
                  <div class="table-wrap no-line-mg">
                    <table class="table-body-only">
                      <caption>신청사항 정보 테이블</caption>
                      <colgroup class="pc-cell">
                        <col style="width: 160px">
                        <col>
                      </colgroup>
                      <colgroup class="mo-cell">
                        <col style="width: 88px">
                        <col>
                      </colgroup>
                      <tbody>
                      <tr>
                        <th scope="row">신청인원<span class="must">*</span></th>
                        <td>
                          <div class="flex align-items-center">
                            <div class="input-area">
                              <input type="text" v-model="editableAdditionalData.APP_PPL" :disabled="!isEditMode" title="신청인원" ref="firstInputAdditional">
                            </div>
                            <span class="font-body-style4" style="margin-left: 8px">명</span>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">근무(활동)기간<span class="must">*</span></th>
                        <td>
                          <div class="flex align-items-center flex-wrap-wrap gap8">
                            <div class="input-area">
                              <input type="date" v-model="editableAdditionalData.WORK_PD_ST"
                                     :disabled="!isEditMode" title="근무(활동)기간 - 시작">
                            </div>
                            <span class="font-body-style4" style="margin-left: 8px; margin-right: 8px">~</span>
                            <div class="input-area">
                              <input type="date" v-model="editableAdditionalData.WORK_PD_ED"
                                     :disabled="!isEditMode" title="근무(활동)기간 - 종료">
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">계속고용여부<span class="must">*</span></th>
                        <td>
                          <p class="font-body-style4">
                            활동(근무)이 만족스러운 경우, (기업 부담의) 계속 고용을 할 의향이 있습니까?
                          </p>
                          <div class="radio-group mt-8 height-fit">
                            <label class="radio-item" for="CTNU_EMPLYM_YN_Y">
                              <input type="radio"
                                     id="CTNU_EMPLYM_YN_Y"
                                     name="CTNU_EMPLYM_YN"
                                     class="sr-only"
                                     value="Y"
                                     v-model="editableAdditionalData.CTNU_EMPLYM_YN"
                                     :disabled="!isEditMode" title="계속 고용 여부 예 선택">
                              <span class="custom-radio"></span>
                              예
                            </label>
                            <div class="input-area"
                                 v-if="editableAdditionalData.CTNU_EMPLYM_YN === 'Y'">
                              <select v-model="editableAdditionalData.CTNU_EMPLYM_PPL" :disabled="!isEditMode" title="계속고용 인원 선택">
                                <option value="">계속고용 인원 선택</option>
                                <option v-for="option in getEmploymentCountOptions"
                                        :key="option.value"
                                        :value="option.value">
                                  {{ option.text }}
                                </option>
                              </select>
                            </div>
                            <label class="radio-item" for="CTNU_EMPLYM_YN_N">
                              <input type="radio"
                                     id="CTNU_EMPLYM_YN_N"
                                     name="CTNU_EMPLYM_YN"
                                     class="sr-only"
                                     value="N"
                                     v-model="editableAdditionalData.CTNU_EMPLYM_YN"
                                     :disabled="!isEditMode" title="계속 고용 여부 아니요 선택">
                              <span class="custom-radio"></span>
                              아니요
                            </label>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <!-- 활동내용 섹션 -->
              <div
                  v-if="(appData.appActcompJob && appData.appActcompJob.length > 0) || (editableJobs && editableJobs.length > 0)">
                <div class="form-section mt-32 job-info-section"
                     v-for="(job, index) in (isEditMode ? editableJobs : appData.appActcompJob)"
                     :key="isEditMode ? index : job.SEQ">
                  <h3 class="section-title mt-40">활동내용 {{ index + 1 }}</h3>
                  <div class="mo-type">
                    <div class="table-wrap no-line-mg">
                      <table class="table-body-only">
                        <caption>활동내용 {{ index + 1 }} 표</caption>
                        <colgroup class="pc-cell">
                          <col style="width: 160px">
                          <col style="width: 348px">
                          <col style="width: 160px">
                          <col>
                        </colgroup>
                        <colgroup class="mo-cell">
                          <col style="width: 88px">
                          <col>
                          <col style="width: 88px">
                          <col>
                        </colgroup>
                        <tbody>
                        <tr>
                          <th scope="row">직무명<span class="must">*</span></th>
                          <td style="padding-right: 16px">
                            <div class="input-area flex-wrap-wrap gap8">
                              <select v-if="isEditMode && (isMetadataLoaded || isLoadingMetadata)"
                                      v-model="job.JOB_CD_NM"
                                      style="width: 160px"
                                      title="직무 선택"
                                      :disabled="isLoadingMetadata"
                                      @change="updateJobCode(job)">
                                <option value="" v-if="isLoadingMetadata">로딩 중...</option>
                                <option value="" v-else>직무를 선택하세요</option>
                                <option v-if="!isLoadingMetadata"
                                        v-for="jobCode in formMetadata.jobCodes"
                                        :key="jobCode.CD"
                                        :value="jobCode.CD_NM">
                                  {{ jobCode.CD_NM }}
                                </option>
                              </select>
                              <input v-else
                                     type="text"
                                     v-model="job.JOB_CD_NM"
                                     style="width: 160px"
                                     readonly
                                     title="상세직무">
                              <input type="text" v-model="job.JOB_DTL_NM" style="width: 148px" :disabled="!isEditMode" title="상세직무명">
                            </div>
                          </td>
                          <th scope="row">희망인원<span class="must">*</span></th>
                          <td>
                            <div class="input-area">
                              <select v-if="isEditMode && (isMetadataLoaded || isLoadingMetadata)"
                                      v-model="job.WISH_PPL"
                                      style="width: 160px"
                                      title="희망인원 선택"
                                      :disabled="isLoadingMetadata">
                                <option value="" v-if="isLoadingMetadata">로딩 중...</option>
                                <option value="" v-else>인원을 선택하세요</option>
                                <option v-if="!isLoadingMetadata"
                                        v-for="option in formMetadata.hopeCountOptions"
                                        :key="option.value"
                                        :value="option.value">
                                  {{ option.text }}
                                </option>
                              </select>
                              <input v-else
                                     type="text"
                                     v-model="job.WISH_PPL"
                                     style="width: 160px"
                                     readonly
                                     title="희망인원">
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">업무내용<span class="must">*</span></th>
                          <td colspan="3">
                            <div class="input-area">
                              <input type="text" v-model="job.JOB_DTL_DESC" :disabled="!isEditMode" title="업무내용">
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">자격사항(필수)<span class="must">*</span></th>
                          <td colspan="3">
                            <div class="input-area">
                              <input type="text" v-model="job.ESSNTL_QUALF_DESC" :disabled="!isEditMode" title="자격사항(필수)">
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">우대사항(우대)<span class="must">*</span></th>
                          <td colspan="3">
                            <div class="input-area">
                              <input type="text" v-model="job.PVLTRT_QUALF_DESC" :disabled="!isEditMode" title="우대사항(우대)">
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">경력사항<span class="must">*</span></th>
                          <td colspan="3">
                            <div class="input-area">
                              <input type="text" v-model="job.EXPRNC_MATTER" :disabled="!isEditMode" title="경력사항">
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">근무장소<span class="must">*</span></th>
                          <td colspan="3">
                            <div class="flex align-items-center flex-wrap-wrap gap8">
                              <div class="input-area" style="flex-grow: 1">
                                <input type="text"
                                       v-model="job.ZIPCODE"
                                       :disabled="!isEditMode"
                                       placeholder="우편번호"
                                       @input="handleAddressChange(index)"
                                       title="우편번호">
                              </div>
                              <button type="button"
                                      class="btn btn-primary btn-form-size"
                                      v-if="isEditMode"
                                      @click="searchAddress(index)">
                                주소검색
                              </button>
                              <div class="check-wrap" style="margin-left: 8px" v-if="isEditMode">
                                <input type="checkbox"
                                       class="sr-only"
                                       :id="`same_company_addr_${index}`"
                                       v-model="job.isUseCorporateAddress"
                                       @change="copyCorporateAddress(index)"
                                       title="기업 소재지와 동일">
                                <label :for="`same_company_addr_${index}`">
                                  <span>기업 소재지와 동일</span>
                                </label>
                              </div>
                            </div>
                            <div class="flex mt-8" style="gap: 8px">
                              <div class="input-area" style="flex-grow: 1">
                                <input type="text"
                                       v-model="job.ADDR"
                                       :disabled="!isEditMode"
                                       placeholder="기본주소"
                                       title="기본주소"
                                       @input="handleAddressChange(index)">
                              </div>
                              <div class="input-area" style="flex-grow: 1">
                                <input type="text"
                                       v-model="job.ADDR_DTL"
                                       :disabled="!isEditMode"
                                       placeholder="상세주소"
                                       title="상세주소"
                                       @input="handleAddressChange(index)">
                              </div>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                      <!-- 추가/삭제 버튼 (수정 모드일 때만) -->
                      <div class="button-area tbl" v-if="isEditMode" style="padding-right: 16px;">
                        <button type="button" class="btn btn-xsm btn-primary job-info-add-btn" @click="addJobSection">
                          추가
                        </button>
                        <button type="button" class="btn btn-xsm btn-secondary job-info-remove-btn"
                                @click="removeJobSection(index)" v-if="index > 0">
                          삭제
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 운영계획 섹션 -->
              <div class="form-section mt-32">
                <h3 class="section-title mt-40">운영계획</h3>
                <div class="textarea-wrap">
                  <textarea v-model="editableAdditionalData.OPER_PLAN_DESC" maxlength="1500"
                            :disabled="!isEditMode" title="운영계획"></textarea>
                </div>
              </div>

              <!-- 첨부파일 등록 섹션 -->
              <div v-if="appData.appInfoFile && appData.appInfoFile.length > 0" class="form-section mt-32">
                <h3 class="section-title mt-40">첨부파일 등록</h3>
                <ul class="check-list">
                  <li v-for="(file, index) in appData.appInfoFile" :key="file.ATTCH_FILE_INFO_NO || index"
                      :data-attch-file-info-no="getFileId(file, index)">
                    <div class="tit">{{ file.ATTCH_FILE_DESC || '첨부파일' }}<span class="must" v-if="file.FILE_INFO_YN === 'Y'">*</span></div>
                    <div class="file-input-wrapper" style="padding-right: 16px;">
                      <!-- 수정 모드가 아닐 때: 다운로드 링크 -->
                      <a href="javascript:void(0)" v-if="!isEditMode"
                         :style="{ cursor: file.REALFILENM ? 'pointer' : 'text' }"
                         @click="downloadFile(file)" title="{{ file.REALFILENM || '-' }}">{{ file.REALFILENM || '-' }}</a>

                      <!-- 수정 모드일 때: 파일 업로드 인터페이스 -->
                      <template v-else>
                        <input type="file"
                               :id="`ATTACH_FILE_${getFileId(file, index)}`"
                               style="width: 100%; opacity: 0; position: absolute; cursor: pointer;"
                               :title="(file.ATTCH_FILE_DESC || '첨부파일') + ' 파일 선택'"
                               tabindex="-1"
                               @change="handleFileChange(getFileId(file, index), $event)">
                        <input type="text"
                               :id="`ATTACH_FILE_${getFileId(file, index)}_NAME`"
                               :value="getFileName(getFileId(file, index))"
                               placeholder="첨부파일을 선택하세요."
                               readonly
                               :title="(file.ATTCH_FILE_DESC || '첨부파일') + ' 파일명'">
                        <button type="button"
                                class="btn-file-upload"
                                v-if="!hasFile(getFileId(file, index))"
                                @click="triggerFileInput(getFileId(file, index))">
                          파일추가
                        </button>
                        <button type="button"
                                class="btn btn-secondary btn-sm remove-file-btn"
                                v-if="hasFile(getFileId(file, index))"
                                style="position: relative; margin-left: 5px; min-width: 83px;"
                                @click="removeAttachmentFile(getFileId(file, index))">
                          제거
                        </button>
                      </template>
                    </div>
                  </li>
                </ul>
              </div>

              <!-- 추가 입력 내용 섹션 -->
              <div
                  v-if="(appData.annSubInfoList && appData.annSubInfoList.length > 0) || (editableSubInfoList && editableSubInfoList.length > 0)">
                <div class="form-section mt-32"
                     v-for="(subInfo, index) in (isEditMode ? editableSubInfoList : appData.annSubInfoList)"
                     :key="isEditMode ? index : subInfo.RECANNSUBINFO_NO">
                  <h3 class="section-title mt-40">추가 입력 내용{{ subInfo.SEQ }}<span class="must" v-if="subInfo.ESSNTL_YN === 'Y'">*</span></h3>
                  <div class="table-wrap no-line-mg">
                    <table class="table-body-only">
                      <caption>추가 입력 내용 표{{ subInfo.SEQ }}</caption>
                      <colgroup class="pc-cell">
                        <col style="width: 160px">
                        <col>
                      </colgroup>
                      <colgroup class="mo-cell">
                        <col style="width: 88px">
                        <col>
                      </colgroup>
                      <tbody>
                      <tr>
                        <th scope="row">질문</th>
                        <td style="white-space: pre-line;">{{ subInfo.QST }}</td>
                      </tr>
                      <tr>
                        <th scope="row">답변</th>
                        <td>
                          <!-- 선택형 (라디오) -->
                          <div v-if="subInfo.INFOCD === 'IN34004'" class="radio-group">
                            <label class="radio-item" v-for="(option, optIndex) in parseOptions(subInfo.QST_EX)"
                                   :key="optIndex">
                              <input type="radio" class="sr-only" :value="option" v-model="subInfo.ANSWER" :disabled="!isEditMode" title="선택 선택">
                              <span class="custom-radio"></span>
                              {{ option }}
                            </label>
                          </div>
                          <!-- 체크박스형 -->
                          <div v-else-if="subInfo.INFOCD === 'IN34003'" class="check-wrap">
                            <template v-for="(option, optIndex) in parseOptions(subInfo.QST_EX)" :key="optIndex">
                              <input type="checkbox"
                                     class="sr-only"
                                     :id="`checkbox_${subInfo.RECANNSUBINFO_NO || subInfo.recannsubinfoNo}_${optIndex}`"
                                     :checked="isOptionChecked(subInfo, option)"
                                     :disabled="!isEditMode"
                                     @change="updateCheckboxAnswer(subInfo, option, $event)" :title="`${option} 선택`">
                              <label
                                  :for="`checkbox_${subInfo.RECANNSUBINFO_NO || subInfo.recannsubinfoNo}_${optIndex}`">
                                <span>{{ option }}</span>
                              </label>
                              <br style="margin-bottom: 8px;" v-if="optIndex < parseOptions(subInfo.QST_EX).length - 1">
                            </template>
                          </div>
                          <!-- 단문형 -->
                          <div v-else-if="subInfo.INFOCD === 'IN34002'" class="input-area">
                            <input type="text" v-model="subInfo.ANSWER" maxlength="200" :disabled="!isEditMode" title="답변(단문형)">
                          </div>
                          <!-- 장문형 -->
                          <div v-else-if="subInfo.INFOCD === 'IN34001'" class="textarea-wrap">
                            <textarea v-model="subInfo.ANSWER" maxlength="2000" rows="5"
                                      :disabled="!isEditMode" title="답변(장문형)" name="answer-sentence"></textarea>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <!-- 추가 입력사항이 없을 때 메시지 -->
              <div v-if="!hasAnyAdditionalContent" class="empty-content-message"
                   style="display: flex; flex-direction: column; justify-content: center; align-items: center; min-height: 200px;">
                <div style="font-size: 48px; color: #999; margin-bottom: 20px; opacity: 0.7;">
                  <i class="ico ico-info"></i>
                </div>
                <div style="font-size: 18px; color: #333; font-weight: 500; line-height: 1.5;">
                  이 공고는 추가 입력사항이 없는 공고입니다.
                </div>
              </div>

              <!-- 공공마이데이터 섹션 -->
              <div v-if="shouldShowPublicMyData" class="box-type2 mt-32" id="publicMyDataSection">
                <h3 class="section-title">공공마이데이터</h3>
                <p class="description bt-line">
                  공공마이데이터 인증과정을 통해 각종 증빙서류들을 파일첨부없이 증빙합니다. <br>
                  (4대 사회보험료 완납증명서, 사업자등록증명, 표준재무제표증명(개인), 주민등록표 등초본)
                </p>

                <!-- 조회 모드: 저장된 데이터 표시 (각 항목별로 개별 li) -->
                <div v-if="!isEditMode && hasPublicMyData" class="form-section mt-16 mydata-info-section">
                  <ul class="mydata-example-wrapper type2">
                    <li v-if="publicMyData.L001">{{ publicMyData.L001 }}</li>
                    <li v-if="publicMyData.L022">{{ publicMyData.L022 }}</li>
                    <li v-if="publicMyData.L026">{{ publicMyData.L026 }}</li>
                    <li v-if="publicMyData.L268">{{ publicMyData.L268 }}</li>
                  </ul>
                </div>

                <!-- 수정 모드: 신청하기 버튼 -->
                <div v-if="isEditMode" class="button-area mt-16 fl-start">
                  <a href="javascript:void(0)" class="btn btn-primary btn-xsm"
                     id="mddsApplicationBtn" @click="openMddsInPopup()" title="신청하기">신청하기</a>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <!-- 수정 모드일 때 저장 버튼 -->
        <button type="button" class="btn btn-primary btn-md button-wid150" @click="saveAllChanges"
                v-if="applicableYn === 'Y' && isEditMode">
          저장
        </button>
        <button type="button" class="btn btn-secondary btn-md button-wid150" @click="close">
          닫기
        </button>
        <!-- 수정 모드가 아닐 때 수정하기 버튼 -->
        <button type="button" class="btn btn-primary btn-md button-wid150" @click="modify"
                v-if="applicableYn === 'Y' && !isEditMode">
          <i class="ico ico-pen-wt"></i>
          수정하기
        </button>
      </div>
      <button type="button" class="btn btn-close only-icon" aria-label="닫기" @click="close" title="닫기">
        <i class="ico ico-x-bl"></i>
      </button>
    </div>
  </div>
</template>

<script>
import Axios from 'axios';

export default {
  name: 'company-app-view-template',
  props: ['companyAppViewModal', 'appNo', 'annNo', 'annKindType'],
  data() {
    return {
      appData: {}, // 전체 응답 데이터
      isEditMode: false, // 수정 모드 상태
      isDaumPostcodeLoaded: false, // 다음 우편번호 API 로딩 상태
      editableData: { // 조회/편집 모두에서 사용하는 필드들
        // 조회용 필드
        COMPNM: '',
        RPSTR_NM: '',
        COM_NO: '',
        ZIPCODE: '',
        ADDR: '',
        ADDR_DTL: '',
        TEL_1: '',
        TEL_2: '',
        TEL_3: '',
        EMAIL: '',
        // 편집 가능한 필드들
        MAIN_BSNS_DESC: '',
        FLTM_WRKR_CNT: '',
        SALAMT: '',
        HP_1: '',
        HP_2: '',
        HP_3: '',
        FAX_1: '',
        FAX_2: '',
        FAX_3: '',
        CHARGR_NM: '',
        HOMEPG: ''
      },
      // 이메일 입력 관련 필드
      emailLocal: '', // 이메일 로컬 부분 (@ 앞)
      emailDomain: '', // 이메일 도메인 부분 (@ 뒤)
      emailDirectDomain: '', // 직접입력 도메인
      editableAdditionalData: { // 추가입력사항 편집 가능한 필드들
        APP_PPL: '',
        WORK_PD_ST: '',
        WORK_PD_ED: '',
        CTNU_EMPLYM_YN: '',
        CTNU_EMPLYM_PPL: '',
        OPER_PLAN_DESC: ''
      },
      editableJobs: [], // 활동내용 편집 가능한 배열
      editableSubInfoList: [], // 추가 입력 내용 편집 가능한 배열
      uploadedFiles: {}, // 업로드된 파일들을 관리하는 객체 (파일ID: File객체)
      applicableYn: 'N',
      showTab: 'basicInfo',
      isLoading: false,
      formMetadata: {
        jobCodes: [],
        hopeCountOptions: [],
        formConfig: {}
      },
      isMetadataLoaded: false,
      isLoadingMetadata: false,
      publicMyData: {
        L001: '',  // 주민등록 관련
        L022: '',  // 건강보험 관련
        L026: '',  // 차상위계층 관련
        L268: ''   // 사업자 관련
      }
    };
  },
  watch: {
    companyAppViewModal: {
      handler(newVal) {
        if (newVal) {
          this.getCompanyAppDetail();
          this.showTab = 'basicInfo';
          this.$nextTick(() => {
            if (this.$refs.modalBody) {
              this.$refs.modalBody.scrollTop = 0;
            }
          });
        }
      },
    },
    /**
     * 이메일 로컬 부분 변경 시 전체 이메일 업데이트
     */
    emailLocal() {
      this.updateFullEmail();
    },

    /**
     * 이메일 직접입력 도메인 변경 시 전체 이메일 업데이트
     */
    emailDirectDomain() {
      if (this.emailDomain === 'etc') {
        this.updateFullEmail();
      }
    }
  },
  methods: {
    /**
     * 기업 신청서 상세 조회
     */
    getCompanyAppDetail() {
      if (!this.appNo) {
        console.error('appNo가 필요합니다.');
        alert('신청서 정보를 불러올 수 없습니다.');
        return;
      }

      this.isLoading = true;
      const url = `/api/in/app/company/${this.appNo}/detail`;

      Axios.get(url).then((response) => {
        if (response.data.success === 'R') {
          this.appData = response.data.data;

          // 편집 가능한 필드 데이터 설정 (조회/수정 모드 모두에서 사용)
          if (this.appData.appInfoView) {
            this.editableData = {
              // 조회용 필드 추가
              COMPNM: this.appData.appInfoView.COMPNM || '',
              RPSTR_NM: this.appData.appInfoView.RPSTR_NM || '',
              COM_NO: this.appData.appInfoView.COM_NO || '',
              ZIPCODE: this.appData.appInfoView.ZIPCODE || '',
              ADDR: this.appData.appInfoView.ADDR || '',
              ADDR_DTL: this.appData.appInfoView.ADDR_DTL || '',
              TEL_1: this.appData.appInfoView.TEL_1 || '',
              TEL_2: this.appData.appInfoView.TEL_2 || '',
              TEL_3: this.appData.appInfoView.TEL_3 || '',
              EMAIL: this.appData.appInfoView.EMAIL || '',
              // 편집 가능한 필드
              MAIN_BSNS_DESC: this.appData.appInfoView.MAIN_BSNS_DESC || '',
              FLTM_WRKR_CNT: this.appData.appInfoView.FLTM_WRKR_CNT || '',
              SALAMT: this.appData.appInfoView.SALAMT || '',
              HP_1: this.appData.appInfoView.HP_1 || '',
              HP_2: this.appData.appInfoView.HP_2 || '',
              HP_3: this.appData.appInfoView.HP_3 || '',
              FAX_1: this.appData.appInfoView.FAX_1 || '',
              FAX_2: this.appData.appInfoView.FAX_2 || '',
              FAX_3: this.appData.appInfoView.FAX_3 || '',
              CHARGR_NM: this.appData.appInfoView.CHARGR_NM || '',
              HOMEPG: this.appData.appInfoView.HOMEPG || ''
            };

            // 추가입력사항 데이터 설정
            this.editableAdditionalData = {
              APP_PPL: this.appData.appInfoView.APP_PPL || '',
              WORK_PD_ST: this.appData.appInfoView.WORK_PD_ST || '',
              WORK_PD_ED: this.appData.appInfoView.WORK_PD_ED || '',
              CTNU_EMPLYM_YN: this.appData.appInfoView.CTNU_EMPLYM_YN || '',
              CTNU_EMPLYM_PPL: this.appData.appInfoView.CTNU_EMPLYM_PPL || '',
              OPER_PLAN_DESC: this.appData.appInfoView.OPER_PLAN_DESC || ''
            };

            // 공공마이데이터 정보 설정
            this.publicMyData = {
              L001: this.appData.appInfoView.L001 || '',
              L022: this.appData.appInfoView.L022 || '',
              L026: this.appData.appInfoView.L026 || '',
              L268: this.appData.appInfoView.L268 || ''
            };

            // 이메일 주소 파싱 (로컬/도메인 분리)
            this.parseEmailAddress(this.editableData.EMAIL);
          }

          // 활동내용 데이터 복사 및 체크박스 상태 초기화
          if (this.appData.appActcompJob) {
            this.editableJobs = JSON.parse(JSON.stringify(this.appData.appActcompJob));
            // 각 job에 체크박스 상태 관리용 플래그 추가
            this.editableJobs.forEach(job => {
              job.isUseCorporateAddress = false;
            });
          }

          // 추가 입력 내용 데이터 복사
          if (this.appData.annSubInfoList) {
            this.editableSubInfoList = JSON.parse(JSON.stringify(this.appData.annSubInfoList));
          }

          // 수정 가능 여부 확인 (기본값: N)
          this.applicableYn = 'Y'; // 기업 신청서는 기본적으로 수정 가능

          // 메타데이터 로드 (annNo가 있을 때)
          if (this.annNo) {
            this.loadFormMetadata();
          }
        } else {
          console.error('기업 신청서 조회 실패:', response.data);
          alert(response.data.message || '신청서 조회에 실패했습니다.');
        }
      }).catch((error) => {
        console.error('기업 신청서 조회 오류:', error);
        const message = (error.response && error.response.data && error.response.data.message) || '신청서 조회 중 오류가 발생했습니다.';
        alert(message);
      }).finally(() => {
        this.isLoading = false;
      });
    },

    /**
     * 폼 메타데이터 로드 (직무코드, 인원수 옵션 등)
     */
    async loadFormMetadata() {
      if (!this.annNo) {
        console.error('annNo가 필요합니다.');
        return;
      }

      this.isLoadingMetadata = true;
      this.isMetadataLoaded = false;

      try {
        const response = await Axios.get(`/api/in/app/company/app-form-metadata?annNo=${this.annNo}`);

        if (response.data.success === 'R') {
          const metadata = response.data.data;

          // 직무 코드 설정 (API에서 받은 데이터 사용)
          if (metadata.jobCodes) {
            this.formMetadata.jobCodes = metadata.jobCodes.map(job => ({
              CD: job.code,
              CD_NM: job.label
            }));
          }

          // 희망 인원수 옵션 설정 (API에서 직접 제공)
          if (metadata.hopeCountOptions) {
            this.formMetadata.hopeCountOptions = metadata.hopeCountOptions.map(option => ({
              value: option.code,
              text: option.label
            }));
          }

          // 폼 설정 정보 저장
          this.formMetadata.formConfig = metadata.formConfig || {};

          this.isMetadataLoaded = true;
        } else {
          console.error('폼 메타데이터 조회 실패:', response.data);
          // 기본값으로 설정
          this.setDefaultMetadata();
        }
      } catch (error) {
        console.error('폼 메타데이터 로드 오류:', error);
        // 오류 시 기본값으로 설정
        this.setDefaultMetadata();
      } finally {
        this.isLoadingMetadata = false;
      }
    },

    /**
     * 기본 메타데이터 설정 (API 실패 시 폴백)
     */
    setDefaultMetadata() {
      // API 실패 시에는 빈 배열로 설정하여 드랍다운 비활성화
      this.formMetadata.jobCodes = [];
      this.formMetadata.hopeCountOptions = [];
      this.formMetadata.formConfig = {};
      this.isMetadataLoaded = false; // API 실패 시에는 false로 설정
    },

    /**
     * 탭 변경
     */
    changeTab(tabId) {
      this.showTab = tabId;
    },

    /**
     * 모달 닫기
     */
    close() {
      this.initializeData();
      this.$emit('update:companyAppViewModal', false);
    },

    /**
     * 데이터 초기화
     */
    initializeData() {
      this.appData = {};
      this.isEditMode = false; // 수정 모드 초기화
      this.editableData = {
        // 조회용 필드
        COMPNM: '',
        RPSTR_NM: '',
        COM_NO: '',
        ZIPCODE: '',
        ADDR: '',
        ADDR_DTL: '',
        TEL_1: '',
        TEL_2: '',
        TEL_3: '',
        EMAIL: '',
        // 편집 가능한 필드들
        MAIN_BSNS_DESC: '',
        FLTM_WRKR_CNT: '',
        SALAMT: '',
        HP_1: '',
        HP_2: '',
        HP_3: '',
        FAX_1: '',
        FAX_2: '',
        FAX_3: '',
        CHARGR_NM: '',
        HOMEPG: ''
      };
      this.editableAdditionalData = {
        OPER_PLAN_DESC: '',
        APP_PPL: '',
        WORK_PD_ST: '',
        WORK_PD_ED: '',
        CTNU_EMPLYM_YN: '',
        CTNU_EMPLYM_PPL: ''
      };
      this.editableJobs = [];
      this.editableSubInfoList = [];
      this.uploadedFiles = {};
      this.applicableYn = 'N';
      this.showTab = 'basicInfo';
      this.isLoading = false;

      // 이메일 관련 필드 초기화
      this.emailLocal = '';
      this.emailDomain = '';
      this.emailDirectDomain = '';

      // 공공마이데이터 초기화
      this.publicMyData = {
        L001: '',
        L022: '',
        L026: '',
        L268: ''
      };

      // 메타데이터 상태 초기화
      this.isMetadataLoaded = false;
      this.isLoadingMetadata = false;
      this.formMetadata = {
        jobCodes: [],
        hopeCountOptions: [],
        formConfig: {}
      };
    },

    /**
     * 전화번호 포맷팅
     */
    formatPhoneNumber(tel1, tel2, tel3) {
      if (!tel1 && !tel2 && !tel3) {
        return '-';
      }
      const parts = [];
      if (tel1) parts.push(tel1);
      if (tel2) parts.push(tel2);
      if (tel3) parts.push(tel3);
      return parts.join('-');
    },

    /**
     * 이메일 도메인 선택 변경 처리
     */
    onEmailDomainChange() {
      if (this.emailDomain !== 'etc') {
        this.emailDirectDomain = '';
      }
      this.updateFullEmail();
    },

    /**
     * 전체 이메일 주소 업데이트
     */
    updateFullEmail() {
      if (this.emailLocal) {
        const domain = this.emailDomain === 'etc' ? this.emailDirectDomain : this.emailDomain;
        if (domain) {
          this.editableData.EMAIL = `${this.emailLocal}@${domain}`;
        } else {
          this.editableData.EMAIL = '';
        }
      } else {
        this.editableData.EMAIL = '';
      }
    },

    /**
     * 이메일 주소 분석 (조회된 이메일을 로컬과 도메인으로 분리)
     */
    parseEmailAddress(email) {
      if (!email || !email.includes('@')) {
        this.emailLocal = '';
        this.emailDomain = '';
        this.emailDirectDomain = '';
        return;
      }

      const [local, domain] = email.split('@');
      this.emailLocal = local || '';

      // 기본 도메인 목록에 있는지 확인
      const predefinedDomains = [
        'naver.com', 'hanmail.net', 'daum.net', 'gmail.com', 'google.com',
        'nate.com', 'yahoo.com', 'paran.com', 'korea.com', 'freechal.com'
      ];

      if (predefinedDomains.includes(domain)) {
        this.emailDomain = domain;
        this.emailDirectDomain = '';
      } else {
        this.emailDomain = 'etc';
        this.emailDirectDomain = domain || '';
      }
    },

    /**
     * 이메일 주소 유효성 검사
     */
    isValidEmail(email) {
      if (!email) return false;
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return emailRegex.test(email);
    },

    /**
     * 선택지 옵션 파싱 (쉼표로 구분된 문자열을 배열로 변환)
     */
    parseOptions(optionsString) {
      if (!optionsString) return [];
      return optionsString.split(',').map(option => option.trim()).filter(option => option);
    },

    /**
     * 첨부파일 다운로드
     */
    downloadFile(file) {
      if (!file || !file.SAVE_FILE_NM) {
        return;
      }

      // 동적 폼 생성
      const vfrm = document.createElement('form');
      vfrm.method = 'post';
      vfrm.target = '_self';
      vfrm.id = 'tempFileForm';
      vfrm.action = '/in_getfileDown.do';

      // 저장된 파일명 input
      const vipinput1 = document.createElement('input');
      vipinput1.setAttribute('type', 'hidden');
      vipinput1.setAttribute('name', 'SAVE_FILE_NM');
      vipinput1.setAttribute('value', file.SAVE_FILE_NM);
      vfrm.appendChild(vipinput1);

      // 실제 파일명 input
      const vipinput2 = document.createElement('input');
      vipinput2.setAttribute('type', 'hidden');
      vipinput2.setAttribute('name', 'REALFILENM');
      vipinput2.setAttribute('value', file.REALFILENM);
      vfrm.appendChild(vipinput2);

      // 폼을 body에 추가하고 submit
      document.body.appendChild(vfrm);
      vfrm.submit();

      // 폼 제거
      document.body.removeChild(vfrm);
    },

    /**
     * 수정하기 - 수정 모드 활성화
     */
    modify() {
      this.isEditMode = true;
      this.$nextTick(() => {
        if (this.showTab === 'basicInfo' && this.$refs.firstInput) {
          this.$refs.firstInput.focus();
        } else if (this.showTab === 'additionalInfo' && this.$refs.firstInputAdditional) {
          this.$refs.firstInputAdditional.focus();
        }
      });
    },

    /**
     * 필드 식별 및 포커스 이동을 위한 매핑 정보
     */
    getFieldMapping() {
      return {
        // 기본정보 필드들
        'MAIN_BSNS_DESC': { tab: 'basicInfo', selector: 'input[v-model="editableData.MAIN_BSNS_DESC"]' },
        'FLTM_WRKR_CNT': { tab: 'basicInfo', selector: 'input[v-model="editableData.FLTM_WRKR_CNT"]' },
        'SALAMT': { tab: 'basicInfo', selector: 'input[v-model="editableData.SALAMT"]' },
        'TEL_1': { tab: 'basicInfo', selector: 'input[v-model="editableData.TEL_1"]' },
        'HP_1': { tab: 'basicInfo', selector: 'input[v-model="editableData.HP_1"]' },
        'EMAIL': { tab: 'basicInfo', selector: 'input[v-model="emailLocal"]' },
        'CHARGR_NM': { tab: 'basicInfo', selector: 'input[v-model="editableData.CHARGR_NM"]' },

        // 신청사항 필드들
        'APP_PPL': { tab: 'additionalInfo', selector: 'input[v-model="editableAdditionalData.APP_PPL"]' },
        'WORK_PD_ST': { tab: 'additionalInfo', selector: 'input[v-model="editableAdditionalData.WORK_PD_ST"]' },
        'CTNU_EMPLYM_YN': { tab: 'additionalInfo', selector: 'input[v-model="editableAdditionalData.CTNU_EMPLYM_YN"][value="Y"]' }
      };
    },

    /**
     * 첫 번째 오류 필드로 포커스 이동
     */
    moveToFirstError(fieldError) {
      try {
        let targetTab = 'basicInfo';
        let selector = null;

        // 필드 타입별로 선택자 및 탭 결정
        if (fieldError.jobIndex !== undefined) {
          // 활동내용 필드
          targetTab = 'additionalInfo';
          const jobIndex = fieldError.jobIndex;
          const fieldType = fieldError.fieldId.split('_')[0];

          switch (fieldType) {
            case 'JOB':
              if (fieldError.fieldId.includes('JOB_CD_NM')) {
                selector = `input[v-model="editableJobs[${jobIndex}].JOB_CD_NM"]`;
              } else if (fieldError.fieldId.includes('JOB_DTL_DESC')) {
                selector = `textarea[v-model="editableJobs[${jobIndex}].JOB_DTL_DESC"]`;
              }
              break;
            case 'WISH':
              selector = `select[v-model="editableJobs[${jobIndex}].WISH_PPL"]`;
              break;
            case 'ESSNTL':
              selector = `textarea[v-model="editableJobs[${jobIndex}].ESSNTL_QUALF_DESC"]`;
              break;
            case 'PVLTRT':
              selector = `textarea[v-model="editableJobs[${jobIndex}].PVLTRT_QUALF_DESC"]`;
              break;
            case 'EXPRNC':
              selector = `textarea[v-model="editableJobs[${jobIndex}].EXPRNC_MATTER"]`;
              break;
            case 'ZIPCODE':
              selector = `input[v-model="editableJobs[${jobIndex}].ZIPCODE"]`;
              break;
            case 'ADDR':
              selector = `input[v-model="editableJobs[${jobIndex}].ADDR"]`;
              break;
            default:
              console.warn('알 수 없는 필드 타입:', fieldType);
              break;
          }
        } else if (fieldError.fileIndex !== undefined) {
          // 첨부파일 필드
          targetTab = 'additionalInfo';
          const fileIndex = fieldError.fileIndex;
          selector = `input[type="file"][data-file-index="${fileIndex}"]`;
        } else if (fieldError.subInfoIndex !== undefined) {
          // 추가 입력 내용 필드
          targetTab = 'additionalInfo';
          const subInfoIndex = fieldError.subInfoIndex;
          selector = `input[v-model="editableSubInfoList[${subInfoIndex}].ANSWER"], textarea[v-model="editableSubInfoList[${subInfoIndex}].ANSWER"]`;
        } else {
          // 기본정보 및 신청사항 필드
          const fieldMapping = this.getFieldMapping();
          const mapping = fieldMapping[fieldError.fieldId];
          if (mapping) {
            targetTab = mapping.tab;
            selector = mapping.selector;
          }
        }

        // 탭 전환이 필요한 경우
        if (targetTab !== this.showTab) {
          this.changeTab(targetTab);
        }

        // DOM 업데이트 후 포커스 이동
        this.$nextTick(() => {
          if (selector) {
            const targetElement = document.querySelector(selector);
            if (targetElement) {
              // 요소로 스크롤
              targetElement.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              });

              // 포커스 설정
              setTimeout(() => {
                targetElement.focus();
                // 시각적 하이라이트 (선택적)
                targetElement.style.border = '2px solid #ff6b6b';
                setTimeout(() => {
                  targetElement.style.border = '';
                }, 2000);
              }, 300);
            }
          }
        });

      } catch (error) {
        console.error('포커스 이동 중 오류 발생:', error);
      }
    },

    /**
     * 필수값 유효성 검사
     */
    validateRequiredFields() {
      const errors = [];
      const fieldErrors = []; // 포커스 이동용 필드 정보 저장

      // 1. 기본정보 필수값 검사
      if (!this.editableData.MAIN_BSNS_DESC || this.editableData.MAIN_BSNS_DESC.trim() === '') {
        errors.push('기본정보 > 주요사업');
        fieldErrors.push({ fieldId: 'MAIN_BSNS_DESC' });
      }
      if (!this.editableData.FLTM_WRKR_CNT || String(this.editableData.FLTM_WRKR_CNT).trim() === '') {
        errors.push('기본정보 > 상시근로자수');
        fieldErrors.push({ fieldId: 'FLTM_WRKR_CNT' });
      }
      if (!this.editableData.SALAMT || String(this.editableData.SALAMT).trim() === '') {
        errors.push('기본정보 > 매출액');
        fieldErrors.push({ fieldId: 'SALAMT' });
      }
      if (!this.editableData.TEL_1 || !this.editableData.TEL_2 || !this.editableData.TEL_3) {
        errors.push('기본정보 > 전화번호');
        fieldErrors.push({ fieldId: 'TEL_1' });
      }
      if (!this.editableData.HP_1 || !this.editableData.HP_2 || !this.editableData.HP_3) {
        errors.push('기본정보 > 휴대폰번호');
        fieldErrors.push({ fieldId: 'HP_1' });
      }
      if (!this.editableData.EMAIL || this.editableData.EMAIL.trim() === '' || !this.isValidEmail(this.editableData.EMAIL)) {
        errors.push('기본정보 > 이메일');
        fieldErrors.push({ fieldId: 'EMAIL' });
      }
      if (!this.editableData.CHARGR_NM || this.editableData.CHARGR_NM.trim() === '') {
        errors.push('기본정보 > 담당자명');
        fieldErrors.push({ fieldId: 'CHARGR_NM' });
      }

      // 2. 신청사항 필수값 검사
      if (!this.editableAdditionalData.APP_PPL || String(this.editableAdditionalData.APP_PPL).trim() === '') {
        errors.push('신청사항 > 신청인원');
        fieldErrors.push({ fieldId: 'APP_PPL' });
      }
      if (!this.editableAdditionalData.WORK_PD_ST || !this.editableAdditionalData.WORK_PD_ED) {
        errors.push('신청사항 > 근무(활동)기간');
        fieldErrors.push({ fieldId: 'WORK_PD_ST' });
      }
      if (!this.editableAdditionalData.CTNU_EMPLYM_YN) {
        errors.push('신청사항 > 계속고용여부를 선택하세요.');
        fieldErrors.push({ fieldId: 'CTNU_EMPLYM_YN' });
      }

      // 3. 활동내용 필수값 검사
      if (this.editableJobs && this.editableJobs.length > 0) {
        this.editableJobs.forEach((job, index) => {
          const sectionNum = index + 1;

          // 기본 정보 필수값 검사
          if (!job.JOB_CD_NM || job.JOB_CD_NM.trim() === '') {
            errors.push(`활동내용 ${sectionNum} > 직무명`);
            fieldErrors.push({ fieldId: `JOB_CD_NM_${index}`, jobIndex: index });
          }
          if (!job.WISH_PPL || String(job.WISH_PPL).trim() === '') {
            errors.push(`활동내용 ${sectionNum} > 희망인원을 선택하세요.`);
            fieldErrors.push({ fieldId: `WISH_PPL_${index}`, jobIndex: index });
          }
          if (!job.JOB_DTL_DESC || job.JOB_DTL_DESC.trim() === '') {
            errors.push(`활동내용 ${sectionNum} > 업무내용`);
            fieldErrors.push({ fieldId: `JOB_DTL_DESC_${index}`, jobIndex: index });
          }
          if (!job.ESSNTL_QUALF_DESC || job.ESSNTL_QUALF_DESC.trim() === '') {
            errors.push(`활동내용 ${sectionNum} > 자격사항(필수)`);
            fieldErrors.push({ fieldId: `ESSNTL_QUALF_DESC_${index}`, jobIndex: index });
          }
          if (!job.PVLTRT_QUALF_DESC || job.PVLTRT_QUALF_DESC.trim() === '') {
            errors.push(`활동내용 ${sectionNum} > 우대사항(우대)`);
            fieldErrors.push({ fieldId: `PVLTRT_QUALF_DESC_${index}`, jobIndex: index });
          }
          if (!job.EXPRNC_MATTER || job.EXPRNC_MATTER.trim() === '') {
            errors.push(`활동내용 ${sectionNum} > 경력사항`);
            fieldErrors.push({ fieldId: `EXPRNC_MATTER_${index}`, jobIndex: index });
          }

          // 근무장소 필수값 검사
          if (!job.ZIPCODE || job.ZIPCODE.trim() === '') {
            errors.push(`활동내용 ${sectionNum} > 근무장소 > 우편번호`);
            fieldErrors.push({ fieldId: `ZIPCODE_${index}`, jobIndex: index });
          }
          if (!job.ADDR || job.ADDR.trim() === '') {
            errors.push(`활동내용 ${sectionNum} > 근무장소 > 기본주소`);
            fieldErrors.push({ fieldId: `ADDR_${index}`, jobIndex: index });
          }
        });
      }

      // 4. 첨부파일 등록 필수값 검사 (FILE_INFO_YN === 'Y'인 경우)
      if (this.appData.appInfoFile && this.appData.appInfoFile.length > 0) {
        this.appData.appInfoFile.forEach((file, index) => {
          if (file.FILE_INFO_YN === 'Y') {
            // 기존 파일이 있는지 확인
            const hasExistingFile = file.REALFILENM && file.REALFILENM.trim() !== '';
            // 새로 업로드된 파일이 있는지 확인
            const hasNewFile = this.uploadedFiles && this.uploadedFiles[this.getFileId(file, index)];

            if (!hasExistingFile && !hasNewFile) {
              errors.push(`첨부파일 등록 > ${file.ATTCH_FILE_DESC || '첨부파일'}을 등록하세요.`);
              fieldErrors.push({ fieldId: `FILE_${index}`, fileIndex: index });
            }
          }
        });
      }

      // 5. 추가 입력 내용 필수값 검사 (ESSNTL_YN === 'Y'인 경우)
      if (this.editableSubInfoList && this.editableSubInfoList.length > 0) {
        this.editableSubInfoList.forEach((subInfo, index) => {
          if (subInfo.ESSNTL_YN === 'Y') {
            if (!subInfo.ANSWER || subInfo.ANSWER.trim() === '') {
              errors.push(`추가 입력 내용 ${subInfo.SEQ || (index + 1)} > 답변`);
              fieldErrors.push({ fieldId: `SUB_INFO_${index}`, subInfoIndex: index });
            }
          }
        });
      }

      // 오류가 발생한 경우 첫 번째 오류 필드로 포커스 이동
      if (fieldErrors.length > 0) {
        this.moveToFirstError(fieldErrors[0]);
      }

      return errors;
    },

    /**
     * 모든 변경사항 저장
     */
    async saveAllChanges() {
      try {
        // 1. 필수값 유효성 검사
        const validationErrors = this.validateRequiredFields();
        if (validationErrors.length  === 1) {
          alert(validationErrors[0] + '을(를) 입력하세요.');
          return;
        }
        else if (validationErrors.length > 1) {
          alert('다음 필수 항목들을 입력하세요 :\n\n' + validationErrors.join('\n'));
          return;
        }

        // 2. FormData 생성
        const formData = new FormData();

        // 2. 요청 데이터 구성
        // jobInfoList에서 isUseCorporateAddress 플래그 제거
        const jobInfoForSave = this.editableJobs.map(job => {
          const { isUseCorporateAddress, ...jobData } = job;
          return jobData;
        });

        const requestData = {
          ANN_NO: this.annNo,
          companyInfo: this.editableData,
          additionalData: this.editableAdditionalData,
          jobInfoList: jobInfoForSave,
          modifedAttachFileSeqList: [],
          // 공공마이데이터 정보 포함
          mddsData: {
            L001_RST: this.publicMyData.L001 || null,
            L022_RST: this.publicMyData.L022 || null,
            L026_RST: this.publicMyData.L026 || null,
            L268_RST: this.publicMyData.L268 || null
          }
        };

        // 추가 입력 정보를 지정된 형식으로 변환
        if (this.editableSubInfoList && this.editableSubInfoList.length > 0) {
          requestData.additionalInfo = this.editableSubInfoList.map(subInfo => ({
            recannsubinfoNo: subInfo.RECANNSUBINFO_NO || subInfo.recannsubinfoNo,
            answer: subInfo.ANSWER || '',
            detailAnswers: []
          }));

        }

        // 수정된 첨부파일 정보 수집 (기존 파일 제거를 위한 정보만)
        if (this.appData.appInfoFile && this.appData.appInfoFile.length > 0) {
          this.appData.appInfoFile.forEach((file, index) => {
            const fileId = this.getFileId(file, index);

            // 기존 파일이 있었는데 제거된 경우 (제거 버튼으로 삭제된 경우 포함)
            if (file.ATTCH_FILE_INFO_NO && (file._removed || (file.REALFILENM && file.REALFILENM.trim() === ''))) {
              requestData.modifedAttachFileSeqList.push(index + 1);
            }
            // 기존 파일이 있었는데 새 파일로 교체된 경우
            else if (file.ATTCH_FILE_INFO_NO && this.uploadedFiles && this.uploadedFiles[fileId]) {
              requestData.modifedAttachFileSeqList.push(index + 1);
            }
          });
        }

        // JSON 데이터를 FormData에 추가
        formData.append('requestData', JSON.stringify(requestData));

        // 3. 첨부파일 처리 및 메타데이터 처리
        if (this.appData.appInfoFile && this.appData.appInfoFile.length > 0) {
          this.appData.appInfoFile.forEach((file, index) => {
            const fileId = this.getFileId(file, index);
            const attchSeq = index + 1;

            // 해당 파일이 선택되어 있는지 확인 (새 파일 업로드 또는 기존 파일 존재)
            if (this.hasFile(fileId)) {
              // 새 파일이 업로드된 경우 서버가 기대하는 형식으로 파일 추가
              if (this.uploadedFiles && this.uploadedFiles[fileId] && this.uploadedFiles[fileId].file) {
                formData.append(`ATTACH_FILE${attchSeq}`, this.uploadedFiles[fileId].file);
              }

              // ATTCH_FILE_INFO_NO 배열로 추가 (기존 파일인 경우)
              if (file.ATTCH_FILE_INFO_NO) {
                formData.append('ATTCH_FILE_INFO_NO', file.ATTCH_FILE_INFO_NO);
              }

              // attch_seq 배열로 추가 (순서 정보)
              formData.append('attch_seq', attchSeq);
            }
          });
        }

        // 4. API 호출
        const response = await Axios.post(`/api/in/app/company/${this.appNo}/update`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        // 5. 응답 처리
        if (response.data && response.data.success !== 'E') {
          alert('수정이 완료되었습니다.');

          // 수정 모드 종료
          this.isEditMode = false;

          // 2단계: 원본 데이터 동기화 - editableData의 변경 내용을 appData에 반영
          this.syncAppDataFromEditableData();

          // 3단계: 첨부파일 정보 동기화
          this.syncAttachFileData();

        } else {
          // 실패 응답 처리
          const errorMessage = response.data.message || '수정 중 오류가 발생했습니다.';
          console.error('수정 실패:', errorMessage);
          alert('수정 실패: ' + errorMessage);
        }

      } catch (error) {
        console.error('수정 중 오류 발생:', error);

        // 에러 타입에 따른 메시지 처리
        let errorMessage = '수정 중 오류가 발생했습니다.';

        if (error.response) {
          // 서버 응답이 있는 경우
          const status = error.response.status;
          const data = error.response.data;

          if (status === 401 || status === 403) {
            errorMessage = '권한이 없거나 로그인이 필요합니다.';
          } else if (status === 400) {
            errorMessage = data.message || '잘못된 요청입니다.';
          } else if (status === 404) {
            errorMessage = '수정할 수 있는 신청서를 찾을 수 없습니다.';
          } else if (status >= 500) {
            errorMessage = '서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.';
          }

          console.error('서버 응답 오류:', status, data);
        } else if (error.request) {
          // 네트워크 오류
          errorMessage = '네트워크 오류가 발생했습니다. 인터넷 연결을 확인해주세요.';
          console.error('네트워크 오류:', error.request);
        }

        alert(errorMessage);
      }
    },

    /**
     * 활동내용 섹션 추가
     */
    addJobSection() {
      const newJob = {
        SEQ: this.editableJobs.length + 1,
        JOB_CD_NM: '',
        JOB_DTL_NM: '',
        WISH_PPL: '',
        JOB_DTL_DESC: '',
        ESSNTL_QUALF_DESC: '',
        PVLTRT_QUALF_DESC: '',
        EXPRNC_MATTER: '',
        ZIPCODE: '',
        ADDR: '',
        ADDR_DTL: '',
        isUseCorporateAddress: false // 체크박스 상태 관리용 플래그
      };
      this.editableJobs.push(newJob);
    },

    /**
     * 활동내용 섹션 삭제
     */
    removeJobSection(index) {
      if (index > 0 && this.editableJobs.length > 1) {
        this.editableJobs.splice(index, 1);
      }
    },

    /**
     * 체크박스 옵션 선택 여부 확인
     */
    isOptionChecked(subInfo, option) {
      if (!subInfo.ANSWER) return false;
      if (typeof subInfo.ANSWER === 'string') {
        return subInfo.ANSWER.split(',').map(item => item.trim()).includes(option);
      }
      return false;
    },

    /**
     * 체크박스 답변 업데이트
     */
    updateCheckboxAnswer(subInfo, option, event) {
      let currentAnswers = [];

      if (subInfo.ANSWER && typeof subInfo.ANSWER === 'string') {
        currentAnswers = subInfo.ANSWER.split(',').map(item => item.trim()).filter(item => item);
      }

      if (event.target.checked) {
        // 체크된 경우 추가
        if (!currentAnswers.includes(option)) {
          currentAnswers.push(option);
        }
      } else {
        // 체크 해제된 경우 제거
        const index = currentAnswers.indexOf(option);
        if (index > -1) {
          currentAnswers.splice(index, 1);
        }
      }

      // 배열을 콤마로 구분된 문자열로 변환
      subInfo.ANSWER = currentAnswers.join(', ');

      // Vue의 반응성 강제 트리거
      this.$forceUpdate();
    },

    /**
     * 파일 ID 안전하게 가져오기
     */
    getFileId(file, index) {
      // ATTCH_FILE_INFO_NO가 있으면 사용, 없으면 index 사용
      return file.ATTCH_FILE_INFO_NO || `file_${index}`;
    },

    /**
     * 파일 선택 input 트리거
     */
    triggerFileInput(fileInfoNo) {
      const fileInput = document.getElementById(`ATTACH_FILE_${fileInfoNo}`);
      if (fileInput) {
        fileInput.click();
      }
    },

    /**
     * 파일 변경 처리
     */
    handleFileChange(fileInfoNo, event) {
      const file = event.target.files[0];
      if (file) {
        // 업로드된 파일 정보 저장 - 표준화된 구조로 저장
        this.uploadedFiles[fileInfoNo] = {
          file: file,
          name: file.name
        };

        // 파일명 표시 필드 수동 업데이트 (Vue 반응성 보완)
        this.$nextTick(() => {
          const nameInput = document.getElementById(`ATTACH_FILE_${fileInfoNo}_NAME`);
          if (nameInput) {
            nameInput.value = file.name;
          }
        });

        // Vue의 반응성 강제 트리거
        this.$forceUpdate();
      }
    },

    /**
     * 파일명 표시 컴포넌트 초기화 - mount 시점에서 기존 파일 정보 동기화
     */
    initializeFileDisplays() {
      this.$nextTick(() => {
        // 첨부파일 정보가 있는 경우 파일명 표시 필드 초기화
        if (this.appData.appInfoFile && this.appData.appInfoFile.length > 0) {
          this.appData.appInfoFile.forEach((file, index) => {
            const fileId = this.getFileId(file, index);
            const nameInput = document.getElementById(`ATTACH_FILE_${fileId}_NAME`);

            if (nameInput) {
              // 기존 파일명이 있으면 표시, 없으면 placeholder 유지
              const fileName = file.REALFILENM || '';
              nameInput.value = fileName;
            }
          });
        }
      });
    },

    /**
     * 파일명 조회
     */
    getFileName(fileInfoNo) {
      // 1순위: 새로 업로드된 파일이 있으면 우선 표시
      const uploadedFile = this.uploadedFiles[fileInfoNo];
      if (uploadedFile && uploadedFile.name) {
        return uploadedFile.name;
      }

      // 2순위: 기존 파일명 표시
      if (this.appData.appInfoFile) {
        let existingFile = null;

        if (fileInfoNo && fileInfoNo.toString().startsWith('file_')) {
          // file_0, file_1 형태의 ID인 경우 index로 찾기
          const index = parseInt(fileInfoNo.toString().replace('file_', ''));
          existingFile = this.appData.appInfoFile[index];
        } else {
          // 실제 ATTCH_FILE_INFO_NO로 찾기
          existingFile = this.appData.appInfoFile.find(f => f.ATTCH_FILE_INFO_NO === fileInfoNo);
        }

        return existingFile ? existingFile.REALFILENM || '' : '';
      }
      return '';
    },

    /**
     * 직무 선택 시 직무코드 업데이트
     */
    updateJobCode(job) {
      if (job.JOB_CD_NM && this.formMetadata.jobCodes) {
        const selectedJob = this.formMetadata.jobCodes.find(jc => jc.CD_NM === job.JOB_CD_NM);
        if (selectedJob) {
          job.JOB_CD = selectedJob.CD;
        }
      }
    },

    /**
     * 다음 우편번호 API 스크립트 로딩
     */
    loadDaumPostcode() {
      if (this.isDaumPostcodeLoaded || window.daum && window.daum.Postcode) {
        this.isDaumPostcodeLoaded = true;
        return Promise.resolve();
      }

      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = '//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
        script.onload = () => {
          this.isDaumPostcodeLoaded = true;
          resolve();
        };
        script.onerror = () => {
          reject(new Error('다음 우편번호 API 로딩에 실패했습니다.'));
        };
        document.head.appendChild(script);
      });
    },

    /**
     * 주소검색 기능 (다음 우편번호 API)
     */
    async searchAddress(sectionIndex) {
      try {
        await this.loadDaumPostcode();

        if (!window.daum || !window.daum.Postcode) {
          alert('주소검색 서비스를 사용할 수 없습니다.');
          return;
        }

        new window.daum.Postcode({
          oncomplete: (data) => {
            // 각 주소의 노출 규칙에 따라 주소를 조합한다.
            let fullAddr = data.address; // 최종 주소 변수
            let extraAddr = ''; // 조합형 주소 변수

            // 기본 주소가 도로명 타입일때 조합한다.
            if (data.addressType === 'R') {
              // 법정동명이 있을 경우 추가한다.
              if (data.bname !== '') {
                extraAddr += data.bname;
              }
              // 건물명이 있을 경우 추가한다.
              if (data.buildingName !== '') {
                extraAddr += (extraAddr !== '' ? ', ' + data.buildingName : data.buildingName);
              }
              // 조합형주소의 유무에 따라 양쪽에 괄호를 추가하여 최종 주소를 만든다.
              fullAddr += (extraAddr !== '' ? ' (' + extraAddr + ')' : '');
            }

            // 해당 섹션의 job 객체에 주소 정보 설정
            if (this.editableJobs[sectionIndex]) {
              const job = this.editableJobs[sectionIndex];
              job.ZIPCODE = data.zonecode; // 5자리 새우편번호 사용
              job.ADDR = fullAddr;
              job.isUseCorporateAddress = false; // 직접 검색한 경우 체크박스 해제

              // 상세주소 입력란으로 포커스 이동
              this.$nextTick(() => {
                const detailInput = document.querySelector(`input[v-model="editableJobs[${sectionIndex}].ADDR_DTL"]`);
                if (detailInput) {
                  detailInput.focus();
                }
              });
            }
          }
        }).open();
      } catch (error) {
        console.error('주소검색 오류:', error);
        alert('주소검색 중 오류가 발생했습니다.');
      }
    },

    /**
     * 기업 소재지 복사 기능
     */
    copyCorporateAddress(sectionIndex) {
      if (!this.editableJobs[sectionIndex]) {
        return;
      }

      const job = this.editableJobs[sectionIndex];

      if (job.isUseCorporateAddress) {
        // 체크박스가 선택된 경우 - 기업 소재지 정보를 근무장소로 복사
        const memberInfo = this.appData.memberInfo;
        if (memberInfo) {
          job.ZIPCODE = memberInfo.ZIPCODE || '';
          job.ADDR = memberInfo.ADDR || '';
          job.ADDR_DTL = memberInfo.ADDR_DTL || '';
        } else {
          // memberInfo가 없는 경우 editableData의 기업 주소 정보 사용
          job.ZIPCODE = this.editableData.ZIPCODE || '';
          job.ADDR = this.editableData.ADDR || '';
          job.ADDR_DTL = this.editableData.ADDR_DTL || '';
        }
      } else {
        // 체크박스가 해제된 경우 - 주소 필드 초기화
        job.ZIPCODE = '';
        job.ADDR = '';
        job.ADDR_DTL = '';
      }

      // Vue의 반응성 강제 트리거
      this.$forceUpdate();
    },

    /**
     * 주소 변경 감지 - 수동 입력 시 체크박스 해제
     */
    handleAddressChange(sectionIndex) {
      if (this.editableJobs[sectionIndex]) {
        const job = this.editableJobs[sectionIndex];

        // 수동으로 주소를 입력한 경우 "기업 소재지와 동일" 체크박스 해제
        if (job.isUseCorporateAddress) {
          job.isUseCorporateAddress = false;
        }
      }
    },

    /**
     * 2-3단계: editableData의 변경사항을 appData에 동기화
     * 수정 완료 후 화면의 조회 모드에서 최신 데이터가 표시되도록 함
     */
    syncAppDataFromEditableData() {
      if (this.appData.appInfoView && this.editableData) {
        // 2단계: editableData의 값들을 appData.appInfoView에 동기화
        Object.keys(this.editableData).forEach(key => {
          if (this.editableData[key] !== null && this.editableData[key] !== undefined) {
            this.appData.appInfoView[key] = this.editableData[key];
          }
        });

        // 추가입력사항 데이터도 동기화
        if (this.editableAdditionalData) {
          Object.keys(this.editableAdditionalData).forEach(key => {
            if (this.editableAdditionalData[key] !== null && this.editableAdditionalData[key] !== undefined) {
              this.appData.appInfoView[key] = this.editableAdditionalData[key];
            }
          });
        }
      }

      // 3단계: 활동내용(Job) 정보 동기화
      if (this.editableJobs && this.editableJobs.length > 0) {
        // 깊은 복사를 통해 editableJobs의 변경사항을 appData.appActcompJob에 반영
        // isUseCorporateAddress 플래그는 제외하고 복사
        this.appData.appActcompJob = this.editableJobs.map(job => {
          const { isUseCorporateAddress, ...jobData } = job;
          return jobData;
        });
      }

      // 3단계: 추가 입력 정보 동기화
      if (this.editableSubInfoList && this.editableSubInfoList.length > 0) {
        // 깊은 복사를 통해 editableSubInfoList의 변경사항을 appData.annSubInfoList에 반영
        this.appData.annSubInfoList = JSON.parse(JSON.stringify(this.editableSubInfoList));
      }

      // Vue의 반응성 강제 트리거
      this.$forceUpdate();
    },

    /**
     * 첨부파일 정보 동기화
     * 수정 완료 후 업로드된 파일명을 appData에 반영
     */
    syncAttachFileData() {
      if (this.appData.appInfoFile && this.uploadedFiles) {
        this.appData.appInfoFile.forEach((file, index) => {
          const fileId = this.getFileId(file, index);

          // 새로 업로드된 파일이 있는 경우 파일명 업데이트
          if (this.uploadedFiles[fileId] && this.uploadedFiles[fileId].name) {
            file.REALFILENM = this.uploadedFiles[fileId].name;
            // 제거 플래그가 있다면 제거
            delete file._removed;
          }
        });
      }

      // 업로드된 파일 정보 초기화 (저장 완료 후에는 더 이상 필요 없음)
      this.uploadedFiles = {};
    },

    /**
     * 파일이 업로드되어 있는지 확인
     */
    hasFile(fileId) {
      // 새로 업로드된 파일이 있는지 확인 - 새로운 구조에 맞게 수정
      const hasUploadedFile = this.uploadedFiles && this.uploadedFiles[fileId] && this.uploadedFiles[fileId].file;

      // 기존 파일이 있는지 확인 (appData에서)
      if (this.appData.appInfoFile && this.appData.appInfoFile.length > 0) {
        const fileInfo = this.appData.appInfoFile.find(f => this.getFileId(f, this.appData.appInfoFile.indexOf(f)) === fileId);
        const hasExistingFile = fileInfo && fileInfo.REALFILENM && fileInfo.REALFILENM.trim() !== '';
        return hasUploadedFile || hasExistingFile;
      }

      return hasUploadedFile;
    },

    /**
     * 첨부파일 제거
     */
    removeAttachmentFile(fileId) {
      // 업로드된 파일 제거
      if (this.uploadedFiles && this.uploadedFiles[fileId]) {
        delete this.uploadedFiles[fileId];
      }

      // 기존 파일 정보 제거 (appData에서)
      if (this.appData.appInfoFile && this.appData.appInfoFile.length > 0) {
        const fileIndex = this.appData.appInfoFile.findIndex(f => this.getFileId(f, this.appData.appInfoFile.indexOf(f)) === fileId);
        if (fileIndex !== -1) {
          // 기존 파일명 제거 (서버에서는 삭제 처리)
          this.appData.appInfoFile[fileIndex].REALFILENM = '';
          this.appData.appInfoFile[fileIndex].SAVE_FILE_NM = '';
          // 제거된 파일 표시
          this.appData.appInfoFile[fileIndex]._removed = true;
        }
      }

      // 파일명 표시 필드 초기화
      const nameInput = document.getElementById(`ATTACH_FILE_${fileId}_NAME`);
      if (nameInput) {
        nameInput.value = '';
      }

      // 파일 입력 필드 초기화
      const fileInput = document.getElementById(`ATTACH_FILE_${fileId}`);
      if (fileInput) {
        fileInput.value = '';
      }

      // Vue의 반응성 강제 트리거
      this.$forceUpdate();
    },

    /**
     * 공공마이데이터 표시 형식 생성 (실제 데이터 값만 표시)
     */
    formatMydataDisplay() {
      const parts = [];

      if (this.publicMyData.L001) parts.push(this.publicMyData.L001);
      if (this.publicMyData.L022) parts.push(this.publicMyData.L022);
      if (this.publicMyData.L026) parts.push(this.publicMyData.L026);
      if (this.publicMyData.L268) parts.push(this.publicMyData.L268);

      return parts.join(' ');
    },

    /**
     * 공공마이데이터 신청 팝업 열기
     */
    openMddsInPopup() {
      // 기존 모달들 중에서 modal005JB이 있는지 확인, 없으면 생성
      let mddsModal = document.getElementById('modal005JB');
      if (!mddsModal) {
        // modal005JB 컨테이너 동적 생성
        const modalHtml = '<div class="modal__wrap--bg cmp-modal" id="modal005JB"></div>';
        document.body.insertAdjacentHTML('beforeend', modalHtml);
        mddsModal = document.getElementById('modal005JB');
      }

      if (mddsModal) {
        // 팝업 내용이 비어있으면 동적으로 로드
        if (mddsModal.innerHTML.trim() === '') {
          // AJAX로 공공 마이데이터 팝업 내용 로드
          Axios.get('/mddsInPopupComp.do', {
            params: {
              annNo: this.annNo
            }
          }).then(response => {
            if (response.data && response.data.trim().length > 0) {
              mddsModal.innerHTML = response.data;
              // 모달 표시
              mddsModal.style.display = 'flex';
              mddsModal.classList.add('is-active');
            } else {
              console.error('공공 마이데이터 팝업 내용이 비어있습니다.');
              alert('공공 마이데이터 팝업을 로드할 수 없습니다.');
            }
          }).catch(error => {
            console.error('공공 마이데이터 팝업 로드 중 오류:', error);
            alert('공공 마이데이터 팝업을 로드하는 중 오류가 발생했습니다.');
          });
        } else {
          // 이미 로드된 경우 바로 표시
          mddsModal.style.display = 'flex';
          mddsModal.classList.add('is-active');
        }

        // 전역 콜백 함수 설정
        window.mddsPopupCallback = (mddsData) => {
          this.handleMddsCompleted(mddsData);
        };
      } else {
        console.error('modal005JB를 찾을 수 없습니다.');
        alert('공공 마이데이터 팝업 컨테이너를 찾을 수 없습니다.');
      }
    },

    /**
     * 공공마이데이터 처리 완료 콜백 함수
     */
    handleMddsCompleted(resultData) {
      try {
        if (resultData && resultData.success) {
          // 전달할 데이터 결정
          const dataToUse = resultData.data || resultData;

          // 공공마이데이터 결과 데이터 Vue 컴포넌트에 저장
          if (dataToUse) {
            this.publicMyData.L001 = dataToUse.L001_RST || '';
            this.publicMyData.L022 = dataToUse.L022_RST || '';
            this.publicMyData.L026 = dataToUse.L026_RST || '';
            this.publicMyData.L268 = dataToUse.L268_RST || '';
          }

          // 성공 메시지
          alert('공공마이데이터 정보를 성공적으로 받아왔습니다.');

          // 공공마이데이터 모달 닫기 (성공 시에만)
          const modalElement = document.getElementById('modal005JB');
          if (modalElement) {
            modalElement.style.display = 'none';
            modalElement.classList.remove('is-active');
          }

        } else if (resultData && resultData.error) {
          // 오류가 있는 경우
          const message = resultData.message || '공공마이데이터 신청 중 오류가 발생했습니다';
          alert(message + ': ' + (resultData.error || '알 수 없는 오류'));

        } else {
          // 기타 실패 케이스
          const message = resultData.message || '공공마이데이터 인증에 실패했습니다.';
          alert(message);
        }

      } catch (error) {
        console.error('공공마이데이터 콜백 처리 중 오류:', error);
        alert('공공마이데이터 처리 중 오류가 발생했습니다.');
      }
    }
  },
  computed: {
    /**
     * 추가 입력사항 존재 여부
     */
    hasAnyAdditionalContent() {
      // 기본 신청사항은 항상 있으므로 true 반환
      // 활동내용, 첨부파일, 추가 입력 내용 중 하나라도 있으면 true
      return (
          (this.appData.appInfoView && this.appData.appInfoView.APP_PPL) ||
          (this.appData.appActcompJob && this.appData.appActcompJob.length > 0) ||
          (this.appData.appInfoFile && this.appData.appInfoFile.length > 0) ||
          (this.appData.annSubInfoList && this.appData.annSubInfoList.length > 0) ||
          (this.appData.appInfoView && this.appData.appInfoView.OPER_PLAN_DESC)
      );
    },

    /**
     * 공공마이데이터 정보 존재 여부
     */
    hasPublicMyData() {
      return this.publicMyData.L001 ||
             this.publicMyData.L022 ||
             this.publicMyData.L026 ||
             this.publicMyData.L268;
    },

    /**
     * 공공마이데이터 섹션 표시 여부
     */
    shouldShowPublicMyData() {
      // formConfig의 usePublicMyData가 true이고, (데이터가 있거나 수정 모드)인 경우 표시
      const usePublicMyData = this.formMetadata &&
                              this.formMetadata.formConfig &&
                              this.formMetadata.formConfig.usePublicMyData === true;
      return usePublicMyData && (this.hasPublicMyData || this.isEditMode);
    },

    /**
     * 계속고용 인원수 옵션 (API 데이터 그대로 사용)
     */
    getEmploymentCountOptions() {
      if (this.isMetadataLoaded && this.formMetadata.hopeCountOptions) {
        // API에서 받은 hopeCountOptions를 그대로 반환
        return this.formMetadata.hopeCountOptions;
      }

      // 메타데이터 로드 실패 시 빈 배열 반환
      return [];
    }
  },
  mounted() {
    // 컴포넌트 마운트 완료
    this.initializeFileDisplays();

    // postMessage 이벤트 리스너 추가 (팝업과의 통신용 - fallback)
    this.handleMessage = (event) => {
      if (event.data && event.data.type === 'mddsCompleted') {
        this.handleMddsCompleted(event.data.data);
      }
    };
    window.addEventListener('message', this.handleMessage);
  },

  beforeDestroy() {
    // 이벤트 리스너 정리
    if (this.handleMessage) {
      window.removeEventListener('message', this.handleMessage);
    }

    // 전역 콜백 함수 정리
    if (window.mddsPopupCallback) {
      delete window.mddsPopupCallback;
    }
  },

};
</script>

<style scoped>
/* 모달 전용 스타일 */
.empty-content-message {
  text-align: center;
  padding: 40px;
}

pre {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 4px;
  border: 1px solid #e9ecef;
}
</style>



// WEBPACK FOOTER //
// CompanyAppView.vue?b8a44ee2